import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    sources: Array,
    fadeTime: { type: Number, default: 500 }
  }
  static targets = ["image"]
  
  connect() {
    this.currentIndex = 0
    this.preloadImages()
    this.setupImage()
  }
  
  setupImage() {
    this.imageTarget.style.opacity = '1'
    this.imageTarget.style.cursor = 'pointer'
    this.imageTarget.style.transition = `opacity ${this.fadeTimeValue}ms ease-in-out`
  }
  
  preloadImages() {
    this.preloadedImages = []
    this.sourcesValue.forEach((src, index) => {
      const img = new Image()
      img.src = src
      this.preloadedImages[index] = img
    })
  }
  
  switch(event) {
    event?.preventDefault()
    event?.stopPropagation()
    
    this.fadeOut(() => {
      this.currentIndex = (this.currentIndex + 1) % this.sourcesValue.length
      this.imageTarget.src = this.sourcesValue[this.currentIndex]
      this.fadeIn()
    })
  }
  
  fadeOut(callback) {
    this.imageTarget.style.opacity = '0'
    setTimeout(callback, this.fadeTimeValue)
  }
  
  fadeIn() {
    this.imageTarget.style.opacity = '1'
  }
}